import React, { useCallback } from "react";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import { GenericIntegrationTicketSystemListingProps } from "../genericIntegrationTicketConstants";

const columnTitleMap = {
  projectKey: "Ticket Type",
  issueType: "Service Item",
};

function FreshServiceIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.map((col: any) => {
      if (
        col.dataIndex &&
        columnTitleMap[col.dataIndex as keyof typeof columnTitleMap]
      ) {
        col.title =
          columnTitleMap[col.dataIndex as keyof typeof columnTitleMap];
      }
      return col;
    });
    return updatedColumns;
  }, []);
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        {...props}
      />
    </div>
  );
}

export default FreshServiceIntegrationListing;
